import React, { Component } from 'react';
import { jsx, css } from '@emotion/core';

import A from '../../../shared/Anchor/Anchor';
import ItemSlider from '../../../shared/ItemSlider/ItemSlider';
import ProductThumbnail from '../../../shared/ProductThumbnail/ProductThumbnail';
import {
  primary_s98_l83,
  primary_light,
  primary_s15_l20,
} from '../../../shared/lib/colors';

import './LatestBestSellers.scss';

class LatestBestSellers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: 'bestSellers',
    };
  }

  changeTab = selected => event => {
    event.preventDefault();
    this.setState({
      selected: selected,
    });
  };

  renderLatestBestSeller = selected => {
    return (
      <div>
        <ItemSlider
          loading={this.props.loading}
          title="Prodotti"
          primaryColor={this.props.primaryColor}
          uiVariant={this.props.uiVariantThumbnail}
        >
          {this.props[selected].map((product, i) => {
            return (
              <div className="mobile-thumbnail">
                <ProductThumbnail
                  key={product.id}
                  product={product}
                  list="Latest/Bestsellers slider"
                  lazy={i >= 2}
                />
              </div>
            );
          })}
        </ItemSlider>
      </div>
    );
  };

  render() {
    const { selected } = this.state;
    const {
      primaryColor,
      secondaryColor,
      uiVariantMenu,
      uiVariantThumbnail,
    } = this.props;

    const liStyle = css`
      &.variant-1 {
        a {
          background-color: ${primary_light(primaryColor)};
          border-radius: 12px;
        }
        &:focus,
        &:hover,
        &.active {
          a {
            background-color: ${primary_s98_l83(secondaryColor)};
          }
        }
      }

      &.variant-2 {
        a {
          color: ${primaryColor};
          border: 1px solid ${primaryColor};
        }
        &:focus,
        &:hover,
        &.active {
          a {
            color: #fff;
            background-color: ${primaryColor};
          }
        }
      }

      &.variant-3 {
        a {
          color: ${primary_s15_l20(primaryColor)};
          text-transform: uppercase;
        }
        &:focus,
        &:hover,
        &.active {
          a {
            color: ${primaryColor};
          }
        }
      }
    `;

    return (
      <div className="container">
        <div className="latest-best-sellers">
          <div className="nav nav-pills">
            <div
              role="presentation"
              className={`nav-pills-item variant-${uiVariantMenu} ${
                selected === 'bestSellers' ? 'active' : ''
              }`}
              css={liStyle}
            >
              <A href="#" onClick={this.changeTab('bestSellers')}>
                Più venduti
              </A>
            </div>
            <div
              role="presentation"
              className={`nav-pills-item variant-${uiVariantMenu} ${
                selected === 'latest' ? 'active' : ''
              }`}
              css={liStyle}
            >
              <A href="#" onClick={this.changeTab('latest')}>
                Ultimi arrivi
              </A>
            </div>
          </div>
          {this.renderLatestBestSeller(selected)}
        </div>
      </div>
    );
  }
}

export default LatestBestSellers;
